import React from 'react';

import {useI18n} from '@udemy/i18n';
import {useUDData} from '@udemy/ud-data';
import {Button, Image} from '@udemy/react-core-components';
import {UFBNoticeClickEvent,UFBNoticeImpressionEvent} from 'udemy-django-static/js/browse/events';
import {Tracker, TrackImpression} from '@udemy/event-tracking';
import {udLink} from '@udemy/ud-data';
import {ubLogoUrl} from 'udemy-django-static/js/utils/udemy-logo-urls';
import styles from './ufb-section.module.less';

const urlUdemyBusiness = 'https://business.udemy.com/?ref=free_courses&utm_type=mx';
const udemyBusinessNoticePlacement = 'ub-section';

export const UFBSection = () => {
    const {gettext} = useI18n();
    const {request} = useUDData();

    const onClick = () => {
        Tracker.publishEvent(
            new UFBNoticeClickEvent({
                locale: request.locale,
                placement: udemyBusinessNoticePlacement,
            }),
        );
    };

    const onImpressionButton = () => {
        Tracker.publishEvent(
            new UFBNoticeImpressionEvent({
                locale: request.locale,
                placement: udemyBusinessNoticePlacement,
                url: urlUdemyBusiness,
            }),
        );
    };

    return (
        <div data-purpose="ufb" className="section">
            <div className="section-column">
                <Image
                    src={ubLogoUrl}
                    alt="Udemy Business"
                    width={200}
                    height={34}
                    data-purpose="udemy-for-business-logo"
                    className={styles['ufb-logo']}
                />
                <h2 className="ud-heading-serif-xxl section-title" data-purpose="ufb-title">
                    {gettext('Build the skills of the future, today')}
                </h2>
                <p className="ud-text-md section-text">
                    {gettext(
                        'Get free resources from industry leaders to guide your organization toward ' +
                            'its goals. Learn strategies to adapt, continue growing, and support your employees.',
                    )}
                </p>
                <TrackImpression trackFunc={onImpressionButton}>
                    <Button
                        componentClass="a"
                        href={urlUdemyBusiness}
                        data-purpose="section-cta"
                        className={styles['cta']}
                        onClick={onClick}
                    >
                        {gettext('Learn more')}
                    </Button>
                </TrackImpression>
            </div>
            <div className="section-column image-container">
                <Image
                    className="placeholder-image"
                    src={udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/leading-teams-v3.jpg',
                    )}
                    srcSet={`${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/leading-teams-v3.jpg',
                    )} 1x, ${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/leading-teams-2x-v3.jpg',
                    )} 2x`}
                    width={450}
                    height={450}
                    data-purpose="section-image"
                    alt=""
                />
            </div>
        </div>
    );
};
